(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["duality-quiz"] && !Shopify.designMode) return;
  try {
    
const quizData = [
  {
    question: "You're lost in an unfamiliar city with no phone. What’s your first move?",
    options: [
      { text: "Find the nearest crowded spot and start asking questions.", type: "blue" },
      { text: "Wander around, take in the sights, and trust you’ll find your way.", type: "red" }
    ]
  },
  {
    question: "A stranger offers you an envelope with an unknown amount of money inside. What do you do?",
    options: [
      { text: "Take it—opportunities don’t wait.", type: "red" },
      { text: "Leave it—some things come with strings attached.", type: "blue" }
    ]
  },
  {
    question: "You’re at a fork in the road. One path is well-lit and direct. The other is shadowed and mysterious. Which do you choose?",
    options: [
      { text: "The clear path—I like knowing what I’m getting into.", type: "blue" },
      { text: "The unknown path—I’d rather discover what’s hidden.", type: "red" }
    ]
  },
  {
    question: "A wise old man offers you one of two gifts: a key or a map. Which do you take?",
    options: [
      { text: "The key—it unlocks something important.", type: "red" },
      { text: "The map—it shows the bigger picture.", type: "blue" }
    ]
  },
  {
    question: "You're standing at the edge of a rooftop, looking over the city. What’s running through your mind?",
    options: [
      { text: "How far I could jump.", type: "red" },
      { text: "How high I could climb.", type: "blue" }
    ]
  }
];

let current = 0;
let score = 0;

const startBtn = document.querySelector('.start-btn');
const questionDiv = document.querySelector('.question');
const optionsDiv = document.querySelector('.options');
const resultDiv = document.querySelector('.result');
const discountDiv = document.querySelector('.discount');
const restartBtn = document.querySelector('.restart-btn');
const quizButtons = document.querySelector('.quiz-buttons');
const productRedBtn = document.querySelector('.product-btn-red');
const productBlueBtn = document.querySelector('.product-btn-blue');

startBtn.addEventListener('click', () => {
  document.querySelector('.intro-text').style.display = 'none';
  startBtn.style.display = 'none';
  questionDiv.style.display = 'block';
  optionsDiv.style.display = 'flex';
  loadQuestion();
});

restartBtn.addEventListener('click', () => location.reload());

function loadQuestion() {
  if (current >= quizData.length) {
    showResult();
    return;
  }

  const q = quizData[current];
  questionDiv.textContent = q.question;
  optionsDiv.innerHTML = '';

  q.options.forEach(option => {
    const btn = document.createElement('div');
    btn.className = 'option';
    btn.textContent = option.text;
    btn.onclick = () => {
      if (option.type === 'blue') score++;
      current++;
      loadQuestion();
    };
    optionsDiv.appendChild(btn);
  });
}

function showResult() {
  questionDiv.style.display = 'none';
  optionsDiv.style.display = 'none';

  const blackRedText = `You're the type who builds from the ground up. You value structure, strategy, and making sure every move counts. Your strength lies in your ability to stay grounded even when the world spins around you. Some might call it calculated, but you know that real power comes from control.<br><br>Your path is clear—just don’t forget to embrace the occasional wild detour.`;

  const blueOrangeText = `You thrive in the unknown. You chase the thrill, the uncharted, and the beautifully chaotic. Your instincts guide you, and you’re willing to take a leap even when the landing isn’t clear. Keep chasing the unexpected, but remember—sometimes slowing down lets you see opportunities you might have missed.`;

  const redBtn = document.querySelector('.product-btn-red');
  const blueBtn = document.querySelector('.product-btn-blue');

  if (score < 3) {
    resultDiv.innerHTML = blackRedText;
    redBtn.style.display = 'inline-block';
    blueBtn.style.display = 'none';
    redBtn.onclick = () => window.location.href = 'https://theholycitrus.com/products/obsidian';
  } else {
    resultDiv.innerHTML = blueOrangeText;
    redBtn.style.display = 'none';
    blueBtn.style.display = 'inline-block';
    blueBtn.onclick = () => window.location.href = 'https://theholycitrus.com/products/skyburn';
  }

  resultDiv.style.display = 'block';
  discountDiv.style.display = 'block';
  quizButtons.style.display = 'flex';
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
